import * as actionTypes from '../actions/vincheck/constants';

const initialState = {
  loading: false, // loader
  data: {},
  error: false,
};

const vinCheckReducer = (state = initialState, action) => {
  const data = state.data ? state.data : {};
  const { id, payload } = action;
  switch (action.type) {
    case actionTypes.FETCH_VINCHECK_REQUEST:
      return {
        loading: true,
        data: { ...data },
        error: false,
      };

    case actionTypes.FETCH_VINCHECK_SUCCESS:
      data[id] = payload;
      return {
        loading: false,
        data: { ...data },
        error: false,
      };

    case actionTypes.FETCH_VINCHECK_FAILURE:
      return {
        loading: false,
        data: { ...data },
        error: action.payload,
      };

    case actionTypes.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default vinCheckReducer;
